module.exports = __webpack_public_path__ + "img/40_38_052_860.0afd717d.jpg";